import { Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'

export function NotFoundPage() {
  return (
    <div className="min-h-screen bg-[#080F14] flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        <p className="text-[120px] sm:text-[180px] font-bold leading-none text-white/[0.04] select-none">
          404
        </p>
        <h2 className="text-2xl font-bold text-white -mt-8 sm:-mt-12 mb-3">
          Page not found
        </h2>
        <p className="text-white/50 mb-8">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center px-6 py-2.5 bg-primary-400 text-dark-500 font-medium rounded-lg hover:bg-primary-300 transition-colors"
          >
            Go home
          </Link>
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center justify-center px-6 py-2.5 bg-white/[0.06] text-white font-medium rounded-lg border border-white/[0.08] hover:bg-white/[0.1] transition-colors"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Go back
          </button>
        </div>
      </div>
    </div>
  )
}
